import { useRoutes } from 'react-router-dom';
import { routes } from './routes';

import { ThemeProvider, Theme, StyledEngineProvider } from '@mui/material';
import GlobalStyles from './components/GlobalStyles';
import { createTheme } from './theme';

declare module '@mui/styles/defaultTheme' {
    // eslint-disable-next-line @typescript-eslint/no-empty-interface
    interface DefaultTheme extends Theme {}
}

export const App = () => {
    const content = useRoutes(routes);
    const theme = createTheme({
        responsiveFontSizes: true,
        mode: 'light',
    });

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                <GlobalStyles />
                {content}
            </ThemeProvider>
        </StyledEngineProvider>
    );
};
